/* tslint:disable */
import {
  Teomemppersonal,
  ViewGoEmp
} from '../index';

declare var Object: any;
export interface TclmuserInterface {
  "userId"?: number;
  "username": string;
  "userUidd"?: string;
  "nickname": string;
  "email": string;
  "status": number;
  "userType": number;
  "isreset": number;
  "flagEula": number;
  "lastLogin"?: Date;
  "lastReset"?: Date;
  "tempPassword"?: string;
  "created": Date;
  "createdBy": string;
  "lastUpdated": Date;
  "modifiedBy": string;
  "userLdap"?: string;
  "userSerialPhone"?: string;
  "imeiPhone"?: string;
  "istnotify"?: number;
  "inviteId"?: string;
  "posInvite"?: string;
  "authFeat"?: string;
  "realm"?: string;
  "challenges"?: any;
  "emailVerified"?: boolean;
  "password"?: string;
  accessTokens?: any[];
  rel_personal?: Teomemppersonal;
  rel_viewpersonal?: ViewGoEmp;
}

export class Tclmuser implements TclmuserInterface {
  "userId": number;
  "username": string;
  "userUidd": string;
  "nickname": string;
  "email": string;
  "status": number;
  "userType": number;
  "isreset": number;
  "flagEula": number;
  "lastLogin": Date;
  "lastReset": Date;
  "tempPassword": string;
  "created": Date;
  "createdBy": string;
  "lastUpdated": Date;
  "modifiedBy": string;
  "userLdap": string;
  "userSerialPhone": string;
  "imeiPhone": string;
  "istnotify": number;
  "inviteId": string;
  "posInvite": string;
  "authFeat": string;
  "realm": string;
  "challenges": any;
  "emailVerified": boolean;
  "password": string;
  accessTokens: any[];
  rel_personal: Teomemppersonal;
  rel_viewpersonal: ViewGoEmp;
  constructor(data?: TclmuserInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tclmuser`.
   */
  public static getModelName() {
    return "Tclmuser";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tclmuser for dynamic purposes.
  **/
  public static factory(data: TclmuserInterface): Tclmuser{
    return new Tclmuser(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tclmuser',
      plural: 'Tclmusers',
      path: 'Tclmusers',
      properties: {
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "userUidd": {
          name: 'userUidd',
          type: 'string'
        },
        "nickname": {
          name: 'nickname',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "userType": {
          name: 'userType',
          type: 'number'
        },
        "isreset": {
          name: 'isreset',
          type: 'number'
        },
        "flagEula": {
          name: 'flagEula',
          type: 'number'
        },
        "lastLogin": {
          name: 'lastLogin',
          type: 'Date'
        },
        "lastReset": {
          name: 'lastReset',
          type: 'Date'
        },
        "tempPassword": {
          name: 'tempPassword',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "userLdap": {
          name: 'userLdap',
          type: 'string'
        },
        "userSerialPhone": {
          name: 'userSerialPhone',
          type: 'string'
        },
        "imeiPhone": {
          name: 'imeiPhone',
          type: 'string'
        },
        "istnotify": {
          name: 'istnotify',
          type: 'number'
        },
        "inviteId": {
          name: 'inviteId',
          type: 'string'
        },
        "posInvite": {
          name: 'posInvite',
          type: 'string'
        },
        "authFeat": {
          name: 'authFeat',
          type: 'string'
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "credentials": {
          name: 'credentials',
          type: 'any'
        },
        "challenges": {
          name: 'challenges',
          type: 'any'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: ''
        },
        rel_personal: {
          name: 'rel_personal',
          type: 'Teomemppersonal',
          model: 'Teomemppersonal'
        },
        rel_viewpersonal: {
          name: 'rel_viewpersonal',
          type: 'ViewGoEmp',
          model: 'ViewGoEmp'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tclmuser.ts